// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2FXYW","subheader":"ReorderModal_subheader__1BnZM","listWrap":"ReorderModal_listWrap__2jQ8s"};